import { Form, Card, Spin } from "antd";
import React, { Component } from "react";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { AccountService } from "../../services/account/AccountService";
import { withRouter } from "react-router-dom";
import Page from "../general/Page";
import "../accounts/Accounts.css";
import "../accounts/AccountForm.css";
import "../accounts/UpdateAccountForm.css";
import { UserService } from "../../services/user/UserService";
import { CfgUserService } from "../../services/cfgUser/CfgUserService";
import { handleError } from "../../utils/ErrorHandlers";
import { Translation } from "react-i18next";
import i18next from "i18next";
class ViewUserForm extends Component {
  constructor(props) {
    super(props);
     this.props.context.setCurrentComponent("viewUsers");
    this.state = {
      user: {},
      isFetching: false,
      isFetchingCfg: false,
      formLayout: "inline",
      loading: false
    };
  }

  async componentDidMount() {
    await this.getUserData();
  }

  async getUserData() {
    let { id } = this.props.match.params;
    this.userServices = new UserService();
try {
  this.setState({ isFetching: true });
  let user = await this.userServices.getUserByIdService(
    this.props.context.session_id,
    id
  );
  this.setState({
    user: user.ivrCustomEntityObject,
    isFetching: false,
  });
} catch (error) {
  this.setState({
    isFetching: false,
  });
  handleError(error);
}
  }

  render() {
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 }
    };
    let { isFetching, isFetchingCfg } = this.state;

    return (
      <Translation>
        {(t) => (
          <Page title={t("View User")} hasBackArrow={true}>
            {isFetching && isFetchingCfg ? (
              <Spin></Spin>
            ) : (
              <div>
                <Card
                  style={{
                    marginTop: "10px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                  }}
                  bordered={false}
                >
                  <Form className="form-style" {...formItemLayout}>
                    <Form.Item label={t("User Email")} {...formItemLayout}>
                      <label>{this.state.user.userEmail} </label>
                    </Form.Item>

                    <Form.Item label={t("User Full Name")} {...formItemLayout}>
                      <label>{this.state.user.userFullname} </label>
                    </Form.Item>

                    <Form.Item label={t("User Birthdate")} {...formItemLayout}>
                      <label>{this.state.user.userBirthdate} </label>
                    </Form.Item>

                    <Form.Item label={t("User Gender")} {...formItemLayout}>
                      <label>
                        {this.state.user.userGender === "M" ? t("Male") : null}
                        {this.state.user.userGender === "F"
                          ? t("Female")
                          : null}{" "}
                      </label>
                    </Form.Item>

                    <Form.Item label={t("User Type")} {...formItemLayout}>
                      <label>
                        {this.state.user.userType === "ADMIN"
                          ? t("Admin")
                          : null}
                        {this.state.user.userType === "AGENT"
                          ? t("Agent")
                          : null}{" "}
                      </label>
                    </Form.Item>

                    <Form.Item label={t("User Number")} {...formItemLayout}>
                      <label>{this.state.user.userNumber} </label>
                    </Form.Item>
                    <Form.Item
                      wrapperCol={{
                        xs: { span: 24, offset: 0 },
                        sm: { span: 16, offset: 8 },
                      }}
                    ></Form.Item>
                  </Form>
                </Card>
              </div>
            )}
          </Page>
        )}
      </Translation>
    );
  }
}
export default Form.create()(withSharedStateConsumer(withRouter(ViewUserForm)));
